import axios, { type AxiosResponse } from 'axios';
import { logger } from '@trading-utils/logger';

import { processBackendError } from '@/utils/error.utils';

import i18n from '@/i18n/config';

import { apiRoutes } from '@/config/apiRoutes';

import type { Masters } from '@/interfaces';

export const getMasters = async (): Promise<Masters> => {
  const url = `${apiRoutes.base}${apiRoutes.masters.base}`;

  try {
    const response: AxiosResponse<Masters> = await axios.get(url);

    logger.info('Retrieved Bioflux masters');

    return response.data;
  } catch (error) {
    logger.error('Error retrieving masters', { url, error });
    throw processBackendError(error, i18n.t('errors.masters.errorGetMasters'));
  }
};
